import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Database.css";
import DataTableComponent from "./DataTable";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaEnvelope, FaInstagram, FaLinkedin } from "react-icons/fa";

const Database = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState("");

  const filterData = (data) => {
    const filter_data = data.filter(
      (item) => item.source_name !== "Test" && item.source_name !== "Test2"
    );
    return filter_data;
  };

  const env_url = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios
      .get(`${env_url}/data`)
      .then((response) => {
        console.log("API Response:", response.data);
        if (response.data && Array.isArray(response.data.Items)) {
          setData(filterData(response.data.Items));
          console.log(response.data.Items);
        } else {
          console.error("Unexpected data format:", response.data);
          setData([]);
          setError("Unexpected data format received from the server.");
        }
      })
      .catch((error) => {
        setData([]);
        setError("Error fetching data");
        console.error("Error fetching data:", error);
      });
  }, []);

  return (
    <div>
      <main>
        <div className="intro intro-top">
          <div className="intro-top-text">
            <h2>About the Database</h2>
            <p className="description">
              Explore curated research from various academic institutions,
              governmental organizations, and NGOs, on the ongoing challenges
              and developments in Afghanistan. Results can be filtered by
              publication date, country of publication, type of publication, and
              topic.
            </p>
          </div>
        </div>
        <div className="table">
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <DataTableComponent data={data} />
            </div>
          </div>
        </div>
      </main>
      <footer className="footer">
        <div className="copy">
          &copy; 2024&ndash;{new Date().getFullYear()} Impact Afghanistan - All Rights Reserved.
        </div>
        <div className="bottom-links">
          <div className="links">
            <a href="mailto:impactcompact.afghanistan@gmail.com">
              <FaEnvelope /> impactcompact.afghanistan@gmail.com
            </a>
            <a
              className="icon-link"
              href="https://www.linkedin.com/in/impactafghanistan/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              className="icon-link"
              href="https://www.instagram.com/impactafghanistan1/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Database;
